import { createAction } from 'redux-actions'
import axios from 'axios';

// 获取二维码照片信息
export const getQRImagesSucceeded = createAction('qrimages/GET_SUCCEEDED')
export const getQRImagesFailed = createAction('qrimages/GET_FAILED')

export function fetchQRImages(params) {
  return dispatch => (
    axios.get('/api/find/qrimage', { params })
      .then(response => dispatch(getQRImagesSucceeded(response)))
      .catch(error => dispatch(getQRImagesFailed(error)))
  )
}

// 审核二维码照片
export const checkQRImageSucceeded = createAction('checkQRImage/GET_SUCCEEDED')
export const checkQRImageFailed = createAction('checkQRImage/GET_FAILED')

export function fetchCheckQRImage(params) {
  return dispatch => (
    axios.post('/api/check/qrimage', params)
      .then(response => dispatch(checkQRImageSucceeded(response)))
      .catch(error => dispatch(checkQRImageFailed(error)))
  )
}

// 导出审核信息
export const getQRImageExportRequested = createAction('QRImageExport/GET_REQUESTED')
export const getQRImageExportSucceeded = createAction('QRImageExport/GET_SUCCEEDED')
export const getQRImageExportFailed = createAction('QRImageExport/GET_FAILED')

export function fetchGetQRImageExport(params) {
  return (dispatch) => {
    dispatch(getQRImageExportRequested);
    return axios.get('/api/find/qrimgExcel', { params })
      .then(response => dispatch(getQRImageExportSucceeded(response)))
      .catch(error => dispatch(getQRImageExportFailed(error)));
  }
}



// WEBPACK FOOTER //
// ./actions/qrimages.js